import { Component, Input, OnInit, Output, ViewChild, TemplateRef, EventEmitter, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ProcExtendProperty } from './extend-property';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-extend-property',
  templateUrl: './extend-property.component.html',
  styleUrls: ['./extend-property.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ExtendPropertyComponent implements OnInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  @Input()
  set value(property: any[]) {
    if (property && property.length > 0) {
      this.procExtendProperty = property.map(p => ({
        id: p.id,
        code: p.code,
        parentId: p.parentId,
        sortOrder: p.sortOrder,
        propertyNote: p.propertyNote,
        propertyTitle: p.propertyTitle,
        propertyLocation: p.propertyLocation,
        propertyType: p.propertyType,
        enumValue: p.enumValue,
        bizDefKey: p.bizDefKey,
        bizCategoryId: p.bizCategoryId,
        startMode: p.startMode,
        value: p.value,
      }));
    }
  }
  modalConfig = {
    title: this.localePipe.transform("component.extendProperty.extendProperty"),
    width: 430,
    height: 370,
    showButtons: true
  };
  procExtendProperty: Array<ProcExtendProperty> = new Array();
  booleanlist = [
    { key: this.localePipe.transform("component.extendProperty.true"), value: 'true' },
    { key: this.localePipe.transform("component.extendProperty.false"), value: 'false' }
  ];
  extendPropertyList = {
    key: '',
    value: ''
  };
  constructor(
    private uiState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  setProperty(obj: any) {
    this.uiState.propertyData = obj.propertyData;
    this.uiState.propertyConfig = obj.propertyConfig;
  }

  ngOnInit() {
  }

  clickOK() {
    const value = this.procExtendProperty;
    const object = { value, parameters: null };
    this.submitModal.emit(object);
  }

  cancel() {
    this.closeModal.emit();
  }
}
export class ExtendPropertyConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data instanceof Array && data.some(item => item.value)) {
      return this.localePipe.transform("component.extendProperty.set");
    }
    return this.localePipe.transform("component.extendProperty.notSet");
  }
}
